import React, { Component } from "react";
import { getMeatCategories } from "../../../../services/items/actions";
import { Link } from "react-router-dom";
import { brandRoute } from "../../../../helpers/restaurantSlugDetector";
import { getAssetUrl } from "../../../helpers/getAssetUrl";
import { connect } from "react-redux";

class MeatCategories extends Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    if (this.props.restaurant_id) {
      this.setState({ isLoading: true });
      this.props.getMeatCategories(this.props.restaurant_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.restaurant_id &&
      this.props.restaurant_id !== prevProps.restaurant_id
    ) {
      this.setState({ isLoading: true });
      this.props.getMeatCategories(this.props.restaurant_id);
    }

    if (this.props.meat_categories !== prevProps.meat_categories) {
      this.setState({ isLoading: false });
    }
  }

   

  render() {
    const { meat_categories, restaurant_slug } = this.props;
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading categories...
        </div>
      );
    }

    const categoryKeys = meat_categories ? Object.keys(meat_categories) : [];

    

    return (
      <>
        {categoryKeys.length > 0 && (
          <div style={{ padding: "15px 10px" }}>
            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                marginBottom: "12px",
                color: "#222",
              }}
            >
              Shop by Category
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "10px",
              }}
            >
              {categoryKeys.map((key) => {
                const category = meat_categories[key];

                return (
                  <Link
                    key={category.id}
                    to={brandRoute(
                      `/store/${restaurant_slug}/category/${category.id}`
                    )}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "1",
                          borderRadius: "18px",
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {category.meat_image && (
                          <img
                            src={getAssetUrl(category.meat_image)}
                            alt={getAssetUrl(category.meat_image)}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              display: "block",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        )}
                      </div>

                      <div
                        className="meat-category-text"
                      >
                        {category.name}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  meat_categories: state.items.meat_categories,
});

export default connect(mapStateToProps, {
  getMeatCategories,
})(MeatCategories);
